export default __webpack_public_path__ + "static/media/Winfred-Yu.2e2c3974.png";